import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Col } from 'antd';

/** Component **/
import RadioList from '../common/radioGroup';
import ButtonGroup from '../common/buttonGroup';
import ImgGroup from '../common/imgGroup';
import { typeMap } from '../../constData';
/** 参数 **/

const errorTypeMap = {
	1: '合格',
	2: '错图',
	3: '歧义',
	4: '相似',
	5: '丑图'
}
class SignDetail extends Component {
	// 标记图片的值
	onchangeRadio = (val) => {
		const { onTagChange } = this.props;
		onTagChange && onTagChange(val)
	}
	// 保存按钮
	onclickSave = ( handleClickSave ) => {
		const { onClickSave, type } = this.props;
		if (type === typeMap.icon_ing || type === typeMap.icon_rework) { // 插画中-保存
			onClickSave && onClickSave();
			return;
		}
		else {
			let value = this._textAreaEle.value;
			onClickSave && onClickSave(value);
		}	
		

		// setTimeout(() => {
		// 	this.onchangeRadio('');
		// 	this._textAreaEle.value = '';
		// }, 0)
	}

	// 处理返工
	onClickReword = () => {
		const { onClickReword } = this.props;
		onClickReword && onClickReword();
	}

	// 处理通过
	onClickPass = () => {
		const { onClickPass, type } = this.props;
		if (type === typeMap.icon_checking || type === typeMap.checking) { // 插画审核中-通过
			onClickPass && onClickPass();
			return;
		}
		else {
			let value = this._textAreaEle.value;
			onClickPass && onClickPass(value);
		}
		
	}

	// 下一题
	onClickNextBtn = () => {
		const { onClickNextBtn } = this.props;
		onClickNextBtn && onClickNextBtn();
	}

	// 编辑参数
	editParam = (obj) => {
		const { editParam } = this.props;
		editParam && editParam(obj);
	}

	// 改变mark
	changeMark = (e) => {
		const value = e.target.value;
		const { onMarkChange } = this.props;
		onMarkChange && onMarkChange(value)
	}

	render () {
		// type - 10标记中,20标记审核中,21标记返工,22待插画(标记审核通过),30插画中,40插画审核中,41插画返工,42题目待审核,50题目审核中,60完成
		const { data, tagValue, type, newImgList, rightDetail, buttonPower } = this.props;
		const { error_type, mark, rework_mark } = rightDetail;
		// 是否显示-图片标记&修改说明
		let isShowTag = (type === typeMap.signing) || (type === typeMap.sign_checking) || (type === typeMap.sign_rework);
		// 是否显示-上传图片-按钮
		let isShowImgBtn = (type === typeMap.icon_ing) || (type === typeMap.icon_checking) || (type === typeMap.icon_rework) || (type === typeMap.checking);
		// 是否显示-图片标记为&修改说明
		let isShowImg = isShowImgBtn || (type === typeMap.finish);
		// 是否显示返工原因
		let isShowRework = (type === typeMap.sign_checking) || (type === typeMap.sign_rework) || (type === typeMap.icon_rework);
		
		return (
			<Col span={9} style={{paddingRight: '20px'}}>
	    		<div className="detailPublic detailSign">
	    			{
	    				isShowRework && rework_mark.length > 0 && 
	    				<div className="section-split">
		    				{/*返工原因*/}
		    				<dl className="section-dl clearfix">
		    					<dt>返工原因：</dt>
		    					<dd className="tag-red">{rework_mark}</dd>
		    				</dl>
		    			</div>
	    			}
	    			{
	    				isShowTag && 
	    				<div className="">
	    					<div className="section-split">
				    			<p>标记图片为：</p>
				    			{/*radio group*/}
								<RadioList
									// value={tagValue}
									errType = {error_type}
									onChange={this.onchangeRadio}
								/>
							</div>
							<div className="section-split">
								<p>修改说明：</p>
								<textarea 
									rows={4} 
									name="text"
									className="modify-explain"
									value={mark}
									onChange={this.changeMark}
									ref={ele => this._textAreaEle = ele}
								>	
								</textarea>
				    		</div>
	    				</div>
	    			}
	    			{
	    				isShowImg &&
	    				<div className="">
	    					<div className="section-split">
			    				{/*图片标记*/}
			    				<dl className="section-dl clearfix">
			    					<dt>图片标记为：</dt>
			    					<dd>{errorTypeMap[error_type]}</dd>
			    				</dl>
			    			</div>
			    			<div className="section-split">
			    				{/*修改说明*/}
			    				<dl className="section-dl clearfix">
			    					<dt>修改说明：</dt>
			    					<dd>{mark}</dd>
			    				</dl>
			    			</div>
			    			<div className="section-split">
				    			{/*img list*/}
		            			<ImgGroup type={type} imgData={data} newImgList={newImgList} editParam={this.editParam} />
				    		</div>
	    				</div>
	    			}
	    			<div className="section-split">
		    			{/*button list*/}
            			<ButtonGroup 
            				onclickSave={this.onclickSave}
            				onClickReword={this.onClickReword}
            				onClickPass={this.onClickPass}
            				onClickNextBtn={this.onClickNextBtn}
            				type={type}
            				buttonPower={buttonPower}
            			/>
	    			</div>
	    		</div>
	    		
        	</Col>
		)
	}
}
const mapStateToProps = () => {
	return {
	};
}
const mapDispatchToProps = () => {
	return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(SignDetail);


// WEBPACK FOOTER //
// ./src/entry_app/question_manage/image_correction/image_correction_detail/sign_detail/view.js